import { Injectable } from '@angular/core';

import {
  CheckEmailAddressResponse,
  DigitalAccount,
  GetDigitalAccountByCdhIdResponse,
  GetDigitalAccountByWaidResponse
} from '../../+state/digital-account/digital-account.model';

@Injectable({
  providedIn: 'root'
})
export class DigitalAccountAdapter {
  constructor() {}

  adaptGetDigitalAccountByCdhId(
    response: GetDigitalAccountByCdhIdResponse,
    cdhId: string
  ): DigitalAccount | null {
    // If 404 status with policies, return null to trigger failure action
    if (response?.status?.code === 404) {
      if (!response?.policies || response.policies.length === 0) {
        throw new Error('No digital account or policies found for this CDH ID');
      } else return null;
    }

    return {
      shellAccount: response.shellAccountIndicator,
      enrollmentRequest: response.enrollmentRequestIndicator,
      verificationInProgress: response.verificationInProgressIndicator,
      maskedEmailAddress: response.maskedEmailAddress,
      maskedPhoneNumbers: response.maskedPhoneNumbers ?? [],
      waid: response.webAccessId ?? '',
      emailAddress: response.emailAddress ?? '',
      customerId: cdhId
    };
  }

  adaptGetDigitalAccountByEmail(
    response: GetDigitalAccountByCdhIdResponse,
    email: string
  ): DigitalAccount | null {
    // could not find account, return inital State
    if (response?.status?.code === 404) {
      return null;
    }

    return {
      shellAccount: response?.shellAccountIndicator ?? false,
      enrollmentRequest: response?.enrollmentRequestIndicator ?? false,
      verificationInProgress: response?.verificationInProgressIndicator ?? false,
      maskedEmailAddress: response?.maskedEmailAddress ?? '',
      maskedPhoneNumbers: response?.maskedPhoneNumbers ?? [],
      waid: response.webAccessId ?? '',
      emailAddress: email,
      customerId: response.customerId ?? '',
      typeOfAccountCode: response.typeOfAccountCode ?? ''
    };
  }

  adaptGetDigitalAccountByWaid(response: GetDigitalAccountByWaidResponse): DigitalAccount {
    return {
      waid: response.digitalAccount?.waid ?? response.shellAccount?.waid ?? '',
      customerId: response.digitalAccount?.customerId ?? response.shellAccount?.customerId ?? '',
      userId: response.digitalAccount?.userId ?? '',
      trackId: response.digitalAccount?.trackId,
      forgeRockId: response.digitalAccount?.forgeRockId,
      userIdLastUpdatedOn: response.digitalAccount?.userIdLastUpdatedOn ?? '',
      typeOfAccountCode:
        response.digitalAccount?.typeOfAccountCode ??
        response.shellAccount?.typeOfAccountCode ??
        '',
      emailAddress:
        response.digitalAccount?.emailAddress ?? response.shellAccount?.emailAddress ?? '',

      nameDetail: response.digitalAccount?.nameDetail ?? response.shellAccount?.nameDetail ?? '',
      shellAccount: !!response.shellAccount,
      mfaActive: !!response.digitalAccount?.mfaActive,
      userAccountStatus: response.digitalAccount?.userAccountStatus,
      lastAuthenticationDate: response.digitalAccount?.lastAuthenticationDate,
      passwordLastChangedDate: response.digitalAccount?.passwordLastChangedDate,
      passwordResetRequired: response.digitalAccount?.passwordResetRequired,
      entUserStatusChangeDate: response.digitalAccount?.entUserStatusChangeDate,
      aaaUsername: response.digitalAccount?.aaaUsername,
      poIUsername: response.digitalAccount?.poIUsername,
      solUsername: response.digitalAccount?.solUsername,
      ciamUsers: response.digitalAccount?.ciamUsers ?? []
    };
  }
  adaptCheckEmailAddress(
    response: CheckEmailAddressResponse,
    correlationId: string
  ): CheckEmailAddressResponse {
    return {
      emailDetail: response.emailDetail,
      correlationId: correlationId,
      status: response.status
    };
  }
}
